export default __webpack_public_path__ + "images/process_8.svg?1f26cdb287dd5d13d22c2d4f75d91823";